export const userAdapter = (user) => {
    return {
        id: user._id,
        name: user.name,
        repoId: user.repo_partner_id,
        origins: user.origins,
        createdAt: user.created_at,
    };
};
